import React from 'react';

import ExportGridProvider from 'components/Grid/providers/ExportGridProvider';
import AccountChartPalettesProvider from 'contextProviders/AccountChartPalettesProvider';
import VisualisationCacheProvider from '../../VisualisationCacheProvider';
import EntityDefinitionsProvider from './EntityDefinitionsProvider';
import LegacySavedFiltersProvider from './LegacySavedFiltersProvider';
import WallboardsProvider from './WallboardsProvider';
import DashboardsProvider from './DashboardsProvider';
import WorkSpacesProvider from './WorkSpacesProvider';
import BoardsProvider from './BoardsProvider';
import ScorecardsProvider from './ScorecardsProvider';
import ReportsProvider from './ReportsProvider';
import MetricAndChartDefinitionsProvider from './MetricAndChartDefinitionsProvider';
import GoalsProvider from './GoalsProvider';
import DashboardGadgetsProvider from './DashboardGadgetsProvider';
import ReportGadgetsProvider from './ReportGadgetsProvider';
import LabelsProvider from './LabelsProvider';

const ContentProviders = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <LabelsProvider>
    <ExportGridProvider>
      <EntityDefinitionsProvider>
        <LegacySavedFiltersProvider>
          <WallboardsProvider>
            <DashboardsProvider>
              <WorkSpacesProvider>
                <BoardsProvider>
                  <ScorecardsProvider>
                    <ReportsProvider>
                      <VisualisationCacheProvider>
                        <MetricAndChartDefinitionsProvider>
                          <GoalsProvider>
                            <DashboardGadgetsProvider>
                              <ReportGadgetsProvider>
                                <AccountChartPalettesProvider>
                                  {children}
                                </AccountChartPalettesProvider>
                              </ReportGadgetsProvider>
                            </DashboardGadgetsProvider>
                          </GoalsProvider>
                        </MetricAndChartDefinitionsProvider>
                      </VisualisationCacheProvider>
                    </ReportsProvider>
                  </ScorecardsProvider>
                </BoardsProvider>
              </WorkSpacesProvider>
            </DashboardsProvider>
          </WallboardsProvider>
        </LegacySavedFiltersProvider>
      </EntityDefinitionsProvider>
    </ExportGridProvider>
  </LabelsProvider>
);

export default ContentProviders;
